import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import i18n, { translate } from './strings/i18n';
import useGetImages from './hooks/useGetImages';
import ErrorMessage from './modal/content/utils/ErrorMessage';
import { DefaultProviders } from '../default-providers';
import ConfigContextProvider from './context';
import ChangePaymentDueDateContent from './modal/content';
const ChangePaymentDueDateRoot = ({ config, selectedAccountId, handleClose }) => {
    const languageInStorage = localStorage.getItem('language');
    const currentState = {
        config,
        selectedAccountId,
        handleClose
    };
    useEffect(() => {
        if (languageInStorage) {
            i18n.changeLanguage(languageInStorage).catch(error => error);
        }
        else {
            localStorage.setItem('language', 'en');
        }
    }, [languageInStorage]);
    const { error: errorImage } = useGetImages();
    return (_jsx(ErrorBoundary, { fallback: _jsx(ErrorMessage, { id: "payment-change-date-root-boundary", image: errorImage, title: translate('errorMessages.troubleRetrievingInformation'), subTitle: translate('errorMessages.tryAgainLater') }), children: _jsx(DefaultProviders, { config: config, children: _jsx(ConfigContextProvider, { state: currentState, children: _jsx(ChangePaymentDueDateContent, {}) }) }) }));
};
export default ChangePaymentDueDateRoot;
